
import { defineComponent, PropType } from 'vue'
const defaultColors = [
  '#ffffff',
  '#f5222d',
  '#fa541c',
  '#fadb14',
  '#52c41a',
  '#1890ff',
  '#722ed1',
  '#8c8c8c',
  '#000000',
  ''
]
export default defineComponent({
  props: {
    value: {
      type: String,
      default: ''
    },
    colors: {
      type: Array as PropType<string[]>,
      default: defaultColors
    }
  },
  emits: ['change'],
  setup(props, context) {
    const onChange = (color: string) => {
      context.emit('change', color)
    }
    return {
      onChange
    }
  }
})
